import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({ selector: '[fecha]' })
export class FechaDirective {

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (
        // Permitir: Eliminar, Retroceso, Tabulador, Escape, Intro
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
        (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
        (e.keyCode === 86 && e.ctrlKey === true) || // Allow: Ctrl+V
        (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
        (e.keyCode === 65 && e.metaKey === true) || // Cmd+A (Mac)
        (e.keyCode === 67 && e.metaKey === true) || // Cmd+C (Mac)
        (e.keyCode === 86 && e.metaKey === true) || // Cmd+V (Mac)
        (e.keyCode === 88 && e.metaKey === true) || // Cmd+X (Mac)
        (e.keyCode >= 35 && e.keyCode <= 39) // Home, End, Left, Right
    ) {
      return;
    }
    // Solo permitir la pulsación de una tecla de número
    if (
        (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
        (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }

    this.el.nativeElement.value = this.darFormatoDeCuenta(this.el.nativeElement.value);
  }

  darFormatoDeCuenta(valorInput: any): string{
    valorInput = valorInput.replace(/[^0-9]/g, '');

    var bloque1 = '';
    var bloque2 = '';
    var bloque3 = '';

    bloque1 = valorInput.substring(0, 2);
    if (bloque1.length == 2) {
      bloque1 = bloque1 + '/';
    }

    bloque2 = valorInput.substring(2, 4);
    if (bloque2.length == 2) {
      bloque2 = bloque2 + '/';
    }

    bloque3 = valorInput.substring(4, 7);

    return bloque1 + bloque2 + bloque3;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: any) {
    const isIE = /msie\s|trident\//i.test(window.navigator.userAgent);
    if (!isIE) {
      event.preventDefault();
      const pastedInput: string = event.clipboardData
          .getData('text/plain')
          .replace(/\D/g, '');
      document.execCommand('insertText', false, pastedInput);
    }

  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
    document.execCommand('insertText', false, textData);
  }

}
